import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'


export default {
  __name: 'TablistGrid',
  props: {
  columns: { type: Array, required: true },
  header: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

const isSimpleGrid = computed(() => props.columns.every(col => typeof col === 'string'))

const colsMap = {
  1: 'grid-cols-1',
  2: 'grid-cols-2',
  3: 'grid-cols-3',
  4: 'grid-cols-4',
  5: 'grid-cols-5',
  6: 'grid-cols-6',
  7: 'grid-cols-7',
  8: 'grid-cols-8'
}

const gridClass = computed(() => {
  const classes = []
  if (isSimpleGrid.value) {
    classes.push(colsMap[props.columns.length])
  }
  if (props.header) {
    classes.push('text-xs uppercase tracking-wider text-gray-500 font-medium whitespace-nowrap')
  }
  return classes
})

const gridStyle = computed(() => {
  if (isSimpleGrid.value) return {}
  const template = props.columns
    .map(col => {
      if (typeof col !== 'string') return col.width
      return /^\d*\.?\d+fr$/.test(col) ? `minmax(80px, ${col})` : col
    })
    .join(' ')
  return { gridTemplateColumns: template }
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid gap-4 w-full", gridClass.value]),
    style: _normalizeStyle(gridStyle.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

}